import React from "react";
import styled from "styled-components";

import { NavLink as RouterNavLink, withRouter } from "react-router-dom";

import PerfectScrollbar from "react-perfect-scrollbar";
import "../../../vendor/perfect-scrollbar.css";

import engageLogo from "../../../assets/engage-full-color.svg";

import { connect } from "react-redux";

import * as actionTypes from "../../../redux/constants";

import {
  Collapse,
  Drawer as MuiDrawer,
  List as MuiList,
  ListItem,
  ListItemText,
  Modal,
} from "@mui/material";

import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import ChatIcon from "@mui/icons-material/Chat";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";

import routes from "../../../routes";

import AddAClientModal from "../../Modals/AddAClientModal/AddAClientModal";

const NavLink = React.forwardRef((props, ref) => (
  <RouterNavLink innerRef={ref} {...props} />
));

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Scrollbar = styled(PerfectScrollbar)`
  background-color: #fff;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  height: 100% !important;
`;

const List = styled(MuiList)`
  background-color: #fff;
`;

const Items = styled.div`
  padding-top: ${(props) => props.theme.spacing(2.5)}px;
  padding-bottom: ${(props) => props.theme.spacing(2.5)}px;
`;

const LinkText = styled(ListItemText)`
  color: ${(props) => props.theme.sidebar.color};
  span {
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
    font-family: DMSans;
  }
  margin-top: 0;
  margin-bottom: 0;
`;

function SidebarLink({ name, to, icon, click }) {
  return (
    <ListItem
      className={"instream-sidebar-link"}
      button
      dense
      component={NavLink}
      to={to}
      activeClassName="active"
      onClick={() => {
        if (click) click();
      }}
    >
      {icon}
      <LinkText>{name}</LinkText>
    </ListItem>
  );
}

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      showAddAClientModal: false,
    };
  }

  toggle = (index) => {
    let state = this.props.sideMenuState.toJS();

    let prevState = state[index];

    Object.keys(state).forEach((item) => {
      state[item] = false;
    });

    state[index] = !prevState;

    this.props.updateSideBarState(state);
  };

  UNSAFE_componentWillMount() {
    if (this.props.sideMenuStateLoaded) return;

    const pathName = this.props.location.pathname;

    let initialMenuState = {};

    routes.forEach((route, index) => {
      const isActive = pathName.indexOf(route.path) === 0;
      const isOpen = route.open;
      const isHome = route.containsHome && pathName === "/" ? true : false;

      initialMenuState = {
        ...initialMenuState,
        [index]: isActive || isOpen || isHome,
      };
    });

    this.props.updateSideBarState(initialMenuState);
  }

  handleClick(e) {
    if (!this.props.open) {
      let targetElement = e.target;

      while (targetElement && targetElement.className) {
        if (
          targetElement.className
            .toString()
            .includes("instream-primary-navigation-collapsed-menu")
        )
          return;
        targetElement = targetElement.parentNode;
      }

      let state = this.props.sideMenuState.toJS();
      Object.keys(state).forEach((item) => {
        state[item] = false;
      });
      this.props.updateSideBarState(state);
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick);
  }

  filterRoute = (r) => {
    if (!r.allowedStates.includes(this.props.menuState)) return false;
    return !r.hide;
  };

  createExpandedSubItemList = (category, sideMenuState, index) => {
    return (
      <Collapse in={sideMenuState[index]} timeout="auto" unmountOnExit>
        {category.children
          .filter((r) => {
            return !r.hide;
          })
          .map((route, index) => (
            <SidebarLink
              key={index}
              name={route.name}
              to={route.path}
              icon={route.icon}
              badge={route.badge}
            />
          ))}
      </Collapse>
    );
  };

  createCollapsedSubItemList = (category, sideMenuState, index) => {
    let menuClass = "instream-primary-navigation-collapsed-menu";
    if (sideMenuState[index]) {
      menuClass += " show";
    }

    return (
      <div className={menuClass}>
        {category.children
          .filter((r) => {
            return !r.hide;
          })
          .map((route, index) => (
            <SidebarLink
              key={index}
              name={route.name}
              to={route.path}
              icon={route.icon}
              badge={route.badge}
              click={() => {
                let state = this.props.sideMenuState.toJS();
                Object.keys(state).forEach((item) => {
                  state[item] = false;
                });
                this.props.updateSideBarState(state);
              }}
            />
          ))}
      </div>
    );
  };

  createSubItemList = (category, sideMenuState, index) => {
    if (this.props.open) {
      return this.createExpandedSubItemList(category, sideMenuState, index);
    }

    return this.createCollapsedSubItemList(category, sideMenuState, index);
  };

  render() {
    const { classes, staticContext, ...other } = this.props;

    let brand = (
      <div className={"instream-brand-logo"}>
        <img src={engageLogo} alt={"Engage"} title={"Engage"} />
      </div>
    );

    const closeAddAClientModal = (clientId) => {
      this.setState({
        showAddAClientModal: false,
      });
    };

    const createAndCloseAddAClientModal = (client, coClient) => {
      closeAddAClientModal();
      this.props.updateClient(client);
      if (coClient) this.props.updateCoClient(coClient);
      else this.props.removeCoClient();

      this.props.removeAllFamilyMember();
      setTimeout(() => {
        let { history } = this.props;
        history.push({
          pathname: `/advisor/clients/details/${client.id}/clientDashboard`,
        });
      }, 10);
    };

    return (
      <Drawer
        className={"instream-primary-navigation"}
        variant="permanent"
        {...other}
      >
        {brand}
        <Scrollbar>
          <List disablePadding>
            <Items>
              <SidebarLink
                name={"Dashboard"}
                to={"/advisor/dashboard"}
                icon={<HomeIcon />}
                click={() => {}}
              />
              <SidebarLink
                name={"Clients"}
                to={"/advisor/clients"}
                icon={<PersonIcon />}
                click={() => {}}
              />
              <SidebarLink
                name={"Glossary"}
                to={"/glossary"}
                icon={<ChatIcon />}
                click={() => {}}
              />
              <ListItem
                className={"instream-sidebar-link"}
                button
                dense
                component="a"
                href="https://vestevo.zendesk.com/hc/en-us"
                target="_blank"
              >
                <ContactSupportIcon />
                <LinkText>Support</LinkText>
              </ListItem>
            </Items>
          </List>
        </Scrollbar>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          className={"detail-creation-modal"}
          disableEnforceFocus={true}
          open={this.state.showAddAClientModal}
          close={closeAddAClientModal}
        >
          <div
            style={{
              top: "10%",
              left: "20%",
              position: "absolute",
              width: "60%",
              border: "2px solid #000",
              padding: "8px 16px 12px",
              boxShadow: "0 0 14px 0 rgba(53,64,82,.05)",
              backgroundColor: "#fff",
            }}
          >
            <AddAClientModal
              save={createAndCloseAddAClientModal}
              close={closeAddAClientModal}
            />
          </div>
        </Modal>
      </Drawer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUserReducer,
    menuState: state.uxStateReducer.get("menuState"),
    sideMenuState: state.uxStateReducer.get("sideMenuState"),
    sideMenuStateLoaded: state.uxStateReducer.get("sideMenuStateLoaded"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMenuToAdminMode: () =>
      dispatch({
        type: actionTypes.SET_MENU_STATE_ADMIN,
      }),
    setMenuToAdvisorMode: () =>
      dispatch({
        type: actionTypes.SET_MENU_STATE_ADVISOR,
      }),
    updateSideBarState: (sideBarState) =>
      dispatch({
        type: actionTypes.SET_SIDE_MENU_STATE,
        data: sideBarState,
      }),
    updateClient: (client) =>
      dispatch({
        type: actionTypes.SET_CURRENT_CLIENT,
        data: client,
      }),
    updateCoClient: (coClient) =>
      dispatch({
        type: actionTypes.SET_CURRENT_COCLIENT,
        data: coClient,
      }),
    removeCoClient: () =>
      dispatch({
        type: actionTypes.REMOVE_COCLIENT,
      }),
    removeAllFamilyMember: () =>
      dispatch({
        type: actionTypes.REMOVE_ALL_FAMILY_MEMBER,
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Sidebar));
